import React, { useCallback, useMemo } from 'react';
import { IDocumentCategory } from 'types/order/documents/IDocumentCategoryType';
import { IStandardDocumentVersionData } from 'types/order/documents/shared/interfaces';
import { Select } from 'ui-toolkit';

export interface IDocumentSelectorProps {
  data: IStandardDocumentVersionData[];
  documentIdsToExclude: string[];

  push: (x: string) => void;
  readOnly: boolean;
  categories: IDocumentCategory[];
}

export const DocumentSelector: React.FC<IDocumentSelectorProps> = ({
  data,
  documentIdsToExclude,
  push,
  readOnly,
  categories,
}) => {
  const categoryForDocument = useCallback(
    (document: IStandardDocumentVersionData) => {
      const category = categories.find((t) => t.name === document.category);
      return category ? category.label : document.category;
    },
    [categories]
  );

  let documentOptions = useMemo(
    () =>
      data
        .filter((item) => documentIdsToExclude.indexOf(item.id) === -1)
        .map((item) => ({
          label: `${item.fileName} (${categoryForDocument(item)})`,
          value: item.id,
        })),
    [categoryForDocument, data, documentIdsToExclude]
  );

  return (
    <Select
      label={`Select a document that's been uploaded`}
      options={documentOptions}
      onChange={(value: any) => {
        push(value.value);
      }}
      isDisabled={readOnly}
    />
  );
};
